export const delDuplicatesFromArray = (array) => {
	let seen = {};
	return array.filter(function (item) {
		let k = JSON.stringify(item);
		return seen.hasOwnProperty(k) ? false : (seen[k] = true);
	})
}

export const capitalizeFirstLetter = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getFilterFromType = (type) => {
	return 'filter' + capitalizeFirstLetter(type)
}

export const getOptionsFromType = (type) => {
	return type + 'Options'
}

export const getChangeFromType = (type) => {
	return 'on' + capitalizeFirstLetter(type) + 'Change'
}

export const getBlurFromType = (type) => {
	return 'on' + capitalizeFirstLetter(type) + 'Blur'
}

export const getDisablesState = (type) => {
	return type + 'Disabled'
}

export const setItemToLocalStorage = (keyName, str) => {
	const myStorage = window.localStorage;
	myStorage.setItem(keyName, str)
}

export const getItemFromLocalStorage = (keyName) => {
	const myStorage = window.localStorage;
	const str = myStorage.getItem(keyName)
	return str ? JSON.parse(str) : ''
}



// WEBPACK FOOTER //
// ./src/react/Helpers/Helpers.js